export enum GenderEnum {
  Female = "0",
  Male = "1",
}
